import ReactDOM from 'react-dom/client';

import App from 'business/App';
import 'technical/time-utils/dayjs.extends';

import './translations';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';

import '@fontsource/nunito/400.css';
import '@fontsource/nunito/700.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root not found');
}

ReactDOM.createRoot(root).render(<App />);
